import { PaginationDuvidas } from 'api/Assessor/duvidas';
import { JobTitleTypes } from 'components/Modal/CadastroPautaModal/CadastroPautaModal';
import { AssemblyModalitiesNumber } from 'helpers/enums/Assembleia';
import {
  AssembleiaPautaStatus,
  AssembleiaPautaStatusString,
  AssembleiaTipoPauta,
  TipoVotoPauta,
} from 'helpers/enums/AssembleiaPautaStatus';
import {
  AssembleiaStatus,
  StatusMensagens,
} from 'helpers/enums/AssembleiaStatus';
import { AssembleiaTipo } from 'helpers/enums/AssembleiaTipo';
import { ParametroTipoResultado } from 'helpers/enums/Parametros';
import { TipoCargosChapa } from 'helpers/enums/TipoCargosChapa';
import {
  AssembleiasAssessorActionTypes,
  ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA,
  ASSEMBLEIAS_ASSESSOR_ACTIONS_DELETE_CURRENT_EVENT,
  ASSEMBLEIAS_ASSESSOR_ACTIONS_DOWNLOAD_FILE_SUCCESS,
  ASSEMBLEIAS_ASSESSOR_ACTIONS_REQUEST_FILE,
  ASSEMBLEIAS_ASSESSOR_ALTERANDO_STATUS_PAUTA,
  ASSEMBLEIAS_ASSESSOR_CLEARED_EVENTO,
  ASSEMBLEIAS_ASSESSOR_EDITED,
  ASSEMBLEIAS_ASSESSOR_LOADED_AGENCIAS_NUCLEOS_SEM_VOTO,
  ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_NUCLEOS_SEM_VOTO,
  ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_PAUTA,
  ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS,
  ASSEMBLEIAS_ASSESSOR_LOADING_DUVIDAS,
  ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO,
  ASSEMBLEIAS_ASSESSOR_LOADING_EVENT_ATTACHMENT,
  ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO,
  ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS,
  ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS_PRESENCIAL,
  ASSEMBLEIAS_ASSESSOR_LOADING_VOTOS_INCONSISTENTES,
  ASSEMBLEIAS_ASSESSOR_LOAD_CONTAS,
  ASSEMBLEIAS_ASSESSOR_LOAD_DUVIDAS,
  ASSEMBLEIAS_ASSESSOR_LOAD_EVENTO,
  ASSEMBLEIAS_ASSESSOR_LOAD_EVENT_ATTACHMENT,
  ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_EVENTO,
  ASSEMBLEIAS_ASSESSOR_LOAD_PAUTAS,
  ASSEMBLEIAS_ASSESSOR_LOAD_VOTOS_INCONSISTENTES,
  ASSEMBLEIAS_ASSESSOR_REFRESH,
  ASSEMBLEIAS_ASSESSOR_UPDATE_QUORUM,
  ASSEMBLEIAS_ASSESSOR_UPDATE_VOTATION,
} from './AssembleiasAssessorActionTypes';
import { AUTH_ACTIONS_LOGOUT, IAuthActionsLogout } from './AuthActionTypes';
import {
  WSAssembleiasActionTypes,
  WS_ASSEMBLEIAS_ACTIONS_OPEN,
} from './WSAssembleiasActionTypes';
import { IWSAssembleia } from './WSAssembleiasReducer';

type DateJSON = string;

export interface IAssembleiaAssessorAgenciaNucleosSemVotoNucleo {
  agencia: string;
  nucleo: string;
  representante: string | null;
}
export interface IAssembleiaAssessorAgenciaNucleosSemVoto {
  idPauta: number;
  agencia: string;
  nucleos: IAssembleiaAssessorAgenciaNucleosSemVotoNucleo[];
}

export interface AssembleiaAssessorDadosInformativos {
  idEvento: number;
  nome: string;
  descricao: string;
  urlTransmissao: string;
  dataEvento: string;
  horarioEvento: string;
  dataFimEvento: string;
  horarioFimEvento: string;
  dataEventoOnline?: string;
  horarioEventoOnline?: string;
  dataFimEventoOnline?: string;
  horarioFimEventoOnline?: string;
}

export interface IAssembleiasAssessorEvent {
  cooperativa: string;
  contasCapital: number;
  dataBloqueio: DateJSON | null;
  dataCadastro: DateJSON;
  dataFimEvento: DateJSON;
  dataEvento: DateJSON;
  dataFimEventoOnline: DateJSON;
  dataEventoOnline: DateJSON;
  descricao: string;
  documentos: IAssembleiasAssessorDocumentos[];
  id: number;
  nome: string;
  presentes: number;
  convidados: number;
  usuariosLogados: number;
  presentesAptos: number;
  existeQuorum: boolean;
  flagIniciarVotacaoDigital: boolean;
  status: AssembleiaStatus;
  modo: AssemblyModalitiesNumber;
  statusChat: StatusMensagens;
  tipo: AssembleiaTipo;
  urlTransmissao: string | null;
  videos: IAssembleiasAssessorYTVideos[];
  pautas?: IAssembleiasAssessorPauta[];
  needLoadPautas: boolean;
  needLoadPautasPresenciais: boolean;
  needLoadAssembleia: boolean;
  quorumAtingido: boolean;
  needLoadQuorum: boolean;
  tipoResultado: ParametroTipoResultado;
  emFinalizacao: boolean;
}

export interface IAssembleiasAssessorDocumentos {
  desDocumento: string;
  nomDocumento: string;
  oidDocumento: number;
  tipoDocumento: string;
  flgDisponivelAssociado: boolean;
}

export interface IAssembleiasAssessorYTVideos {
  descricao: string;
  oidVideo: number;
  urlYoutube: string;
}

export interface IAssembleiasAssessorEventList {
  descricao: string;
  id: number;
  nome: string;
  status: number;
  tipo: string;
}

export interface IAssembleiasAssessorPauta {
  codigoAgencia: string;
  descricao: string;
  idPauta: number;
  hasAnexos: boolean;
  itens: IAssembleiasAssessorItens[];
  numeroNucleo: string;
  ordem: number;
  status: AssembleiaPautaStatus;
  statusPresencial: AssembleiaPautaStatusString;
  tempoVotacao: number;
  tempoRestante: number;
  tipoPauta: AssembleiaTipoPauta;
  podeVotar?: boolean;
  titulo: string;
  votos: any[];
  flgSecreta: boolean;
  flgRestrita: boolean;
  estaVotadoPorOutroRepresentante: boolean;
  resultadoLiberado?: boolean | null;
  resultadoLiberadoAssociado?: boolean | null;
  resultadoLiberadoPresencial?: boolean | null;
  tipoVotoPauta: TipoVotoPauta;
}

export interface IAssembleiasAssessorItens {
  descricao: string;
  flgAbstencao: number;
  idItemPauta: number;
  representantesChapa: IRepresentantesChapa[];
  ordem: number;
}

export interface IRepresentantesChapa {
  associado: string;
  idCargo: 0;
  idRepresentanteChapa: 0;
  nomeCargo: TipoCargosChapa;
}

export interface IAssembleiasAssessoresAlteraStatusPauta {
  idPauta: number;
  minutos: number;
  status: number;
}

export interface IAssembleiasAssessoresRegistrarPresenca {
  convocacoes: number[];
  cpf: string | undefined;
  idEvento: number | undefined;
}

export interface IAssembleiaAssessorLoadContas {
  codigoAgencia: string;
  codigoCooperativa: string;
  cpfCnpj: string;
  cpfRepresentanteConfirmado: string;
  cpfRepresentanteLegal: string;
  idAssociado: number;
  idConvocado: number;
  modoPresenca: number;
  nomeAssociado: string;
  nomeRepresentanteLegal: string;
  numeroConta: string;
  numeroNucleo: string;
  presente: boolean;
  tipoPresenca: number;
  flgTitular: boolean;
  dataPresenca?: null | string;
}

export interface IAssembleiaContasAssessor {
  assembleiaId: number;
  flagPresencaNaoOnline?: boolean;
  contas: IAssembleiaAssessorLoadContas[];
}

export interface IAssembleiaAssessorLoadDuvidas {
  dataDuvida: DateJSON;
  duvida: string;
  idDuvidaFrequente: number;
  usuarioDuvida: string;
}

export interface IListaNucleosPauta {
  nucleo: string;
  presentes: number;
}

export interface IListaAgenciasPauta {
  codigoAgencia: string;
  nucleos: IListaNucleosPauta[];
}

export interface IRequestPautasRespostas {
  codigoAgencia: string;
  idPauta: number;
  itensPauta: IPautaRespostaItemRequest[];
  numeroNucleo: string;
  flagDeclaracaoSemVotos: boolean;
}

export interface IPautaRespostaItemRequest {
  idItemPauta: number;
  quantidadeVotos: number;
}

export interface ICadastrarPautaRequest {
  descricao: string;
  idEvento: number;
  idPauta?: number;
  itens: IItensCadastrarPautaRequest[];
  titulo: string;
  tipoPauta: number;
  codigoAgencia: string;
  numeroNucleo: string;
  flgSecreta: boolean;
  flgRestrita: boolean;
  flgCienteEdicao: boolean;
  membrosCommisao: any;
}

export interface ICadastrarPautaRequest2 {
  eventId: number;
  agenda: {
    eventId: number;
    agendaType: string;
    title: string;
    description: string;
    branch: string;
    nucleus: string;
    flagRestrict: boolean;
    flagSecret: boolean;
    items: [
      {
        description: string;
        flagAbstention: boolean;
        representatives: [
          {
            associateId: number;
            role: string;
          }
        ];
      }
    ];
    electionCommissions: number[];
  };
}

export interface IItensCadastrarPautaRequest {
  id?: string;
  descricao: string;
  flgAbstencao: boolean;
  idItemPauta?: number;
  representantes?: {
    cargo?: JobTitleTypes;
    idAssociado?: number;
    name?: string;
    nomeAssociado?: string;
  }[];
}

export interface IVotosInconsistentes {
  idPauta: number;
  listAgencia: IVIListAgencia[];
  tituloPauta: string;
}

export interface IVIListAgencia {
  agencia: string;
  nucleos: IVINucleo[];
}

export interface IVINucleo {
  nucleo: string;
}

export interface IAssembleiasAssessorReducer {
  loadingEventAttachment: boolean;
  attachments: IAssembleiasAssessorDocumentos[];
  loadingEvento: boolean;
  evento: IAssembleiasAssessorEvent | null;
  loadingListaEvento: boolean;
  listaEvento: IAssembleiasAssessorEventList[];
  needLoadListaEvento: boolean;
  loadingPautas: boolean;
  pautas: IAssembleiasAssessorPauta[];
  alterandoStatusPauta: boolean;
  loadingContas: boolean;
  contasDisponiveis?: IAssembleiaAssessorLoadContas[];
  loadingDuvidas: boolean;
  duvidas: PaginationDuvidas;
  loadingAgenciasPauta: boolean;
  agenciasPauta: IListaAgenciasPauta[];
  downloadindDocument: number[];
  downloadSuccessfully: number[];
  votosInconsistentes: IVotosInconsistentes[];
  loadingVotosInconsistentes: boolean;
  loadingAgenciasNucleosSemVoto: boolean;
  agenciasNucleosSemVoto: IAssembleiaAssessorAgenciaNucleosSemVoto[];
}

const INITIAL_STATE: IAssembleiasAssessorReducer = {
  loadingEventAttachment: false,
  attachments: [],
  loadingEvento: false,
  evento: null,
  loadingListaEvento: false,
  listaEvento: [],
  needLoadListaEvento: true,
  loadingPautas: false,
  pautas: [],
  alterandoStatusPauta: false,
  loadingContas: false,
  loadingDuvidas: false,
  duvidas: {
    elements: [],
    totalElements: 0,
    totalPages: 1,
    countMensagensPendentes: 0,
    countMensagensRespondidas: 0,
    countMensagensEmResposta: 0,
  },
  loadingAgenciasPauta: false,
  agenciasPauta: [],
  downloadindDocument: [],
  downloadSuccessfully: [],
  votosInconsistentes: [],
  loadingVotosInconsistentes: false,
  loadingAgenciasNucleosSemVoto: false,
  agenciasNucleosSemVoto: [],
};

const getRefreshedState = (
  state: IAssembleiasAssessorReducer,
  assembleia: IWSAssembleia
): IAssembleiasAssessorReducer => {
  const newState: IAssembleiasAssessorReducer = { ...state };
  if (
    newState.evento &&
    (newState.evento.id === assembleia.id ||
      newState.evento.id === assembleia.idPauta)
  ) {
    newState.evento = {
      ...newState.evento,
      presentes:
        typeof assembleia.presentes === 'number'
          ? assembleia.presentes
          : newState.evento.presentes,
      contasCapital:
        typeof assembleia.contasCapital === 'number'
          ? assembleia.contasCapital
          : newState.evento.contasCapital,
      usuariosLogados:
        typeof assembleia.usuariosLogados === 'number'
          ? assembleia.usuariosLogados
          : newState.evento.usuariosLogados,
      status:
        typeof assembleia.status === 'number'
          ? assembleia.status
          : newState.evento.status,
      // needLoadPautas: typeof assembleia.needLoadPautas === 'boolean' ? assembleia.needLoadPautas : false,
      statusChat:
        typeof assembleia.statusChat === 'number'
          ? assembleia.statusChat
          : newState.evento.statusChat,
      needLoadQuorum:
        typeof assembleia.needLoadQuorum === 'boolean'
          ? assembleia.needLoadQuorum
          : newState.evento.needLoadQuorum,
      // pautas: newState.evento.pautas
      //   ? newState.evento.pautas.map(pauta => {
      //       const filteredRefreshedPautas = assembleia.pautas
      //         ? assembleia.pautas.filter(pautaRefreshed => pautaRefreshed.idPauta === pauta.idPauta)
      //         : [];
      //       if (filteredRefreshedPautas.length > 0) {
      //         return {
      //           ...pauta,
      //           status:
      //             typeof filteredRefreshedPautas[0].status === 'number'
      //               ? filteredRefreshedPautas[0].status
      //               : pauta.status,
      //           tempoRestante: filteredRefreshedPautas[0].tempoRestante || filteredRefreshedPautas[0].tempoVotacao,
      //           tempoVotacao: filteredRefreshedPautas[0].tempoVotacao,
      //           resultadoLiberado:
      //             filteredRefreshedPautas[0].resultadoLiberado !== null
      //               ? filteredRefreshedPautas[0].resultadoLiberado
      //               : pauta.resultadoLiberado,
      //         };
      //       }
      //       return pauta;
      //     })
      //   : [],
    };
  }
  if (newState.listaEvento && newState.listaEvento.length > 0) {
    newState.listaEvento = newState.listaEvento.map((evento) => {
      if (evento.id === assembleia.id || evento.id === assembleia.idPauta) {
        return {
          ...evento,
          status:
            typeof assembleia.status === 'number'
              ? assembleia.status
              : evento.status,
        };
      }
      return evento;
    });
  }
  return newState;
};

export default function AssembleiasAssessorReducer(
  state: IAssembleiasAssessorReducer = INITIAL_STATE,
  action:
    | AssembleiasAssessorActionTypes
    | WSAssembleiasActionTypes
    | IAuthActionsLogout
) {
  switch (action.type) {
    case WS_ASSEMBLEIAS_ACTIONS_OPEN:
      return {
        ...state,
        needLoadListaEvento: true,
        evento: state.evento
          ? {
              ...state.evento,
              needLoadAssembleia: true,
            }
          : state.evento,
      };
    case ASSEMBLEIAS_ASSESSOR_REFRESH:
      return getRefreshedState(state, action.payload);
    case ASSEMBLEIAS_ASSESSOR_LOADING_EVENTO:
      return {
        ...state,
        loadingEvento: action.payload,
        evento: { ...state.evento, needLoadAssembleia: false },
      };
    case ASSEMBLEIAS_ASSESSOR_LOADING_EVENT_ATTACHMENT:
      return {
        ...state,
        loadingEventAttachment: action.payload,
        evento: { ...state.evento, needLoadAssembleia: false },
      };
    case ASSEMBLEIAS_ASSESSOR_LOAD_EVENTO:
      return {
        ...state,
        evento: {
          ...state.evento,
          ...action.payload,
          refreshedTimes: 0,
          needLoadPautas: true,
        },
      };
    case ASSEMBLEIAS_ASSESSOR_LOAD_EVENT_ATTACHMENT:
      return { ...state, attachments: action.payload };
    case ASSEMBLEIAS_ASSESSOR_CLEARED_EVENTO:
      return { ...state, evento: null };
    case ASSEMBLEIAS_ASSESSOR_ACTIONS_REQUEST_FILE:
      return { ...state, downloadindDocument: action.payload };
    case ASSEMBLEIAS_ASSESSOR_ACTIONS_DOWNLOAD_FILE_SUCCESS:
      return { ...state, downloadSuccessfully: action.payload };
    case ASSEMBLEIAS_ASSESSOR_ACTIONS_DELETE_CURRENT_EVENT:
      return { ...state, evento: null };
    case ASSEMBLEIAS_ASSESSOR_LOADING_LISTA_EVENTO:
      return {
        ...state,
        loadingListaEvento: action.payload,
        needLoadListaEvento: false,
      };
    case ASSEMBLEIAS_ASSESSOR_LOAD_LISTA_EVENTO:
      return { ...state, listaEvento: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS:
      return {
        ...state,
        loadingPautas: action.payload,
        evento: { ...state.evento, needLoadPautas: false },
      };
    case ASSEMBLEIAS_ASSESSOR_LOADING_PAUTAS_PRESENCIAL:
      return {
        ...state,
        loadingPautas: action.payload,
        evento: { ...state.evento, needLoadPautasPresenciais: false },
      };
    case ASSEMBLEIAS_ASSESSOR_LOAD_PAUTAS:
      return { ...state, evento: { ...state.evento, pautas: action.payload } };
    case ASSEMBLEIAS_ASSESSOR_ALTERANDO_STATUS_PAUTA:
      return { ...state, alterandoStatusPauta: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOADING_CONTAS:
      return { ...state, loadingContas: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOAD_CONTAS:
      return {
        ...state,
        contasDisponiveis: action.payload,
        evento: { ...state.evento },
      };
    case ASSEMBLEIAS_ASSESSOR_LOADING_DUVIDAS:
      return { ...state, loadingDuvidas: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOAD_DUVIDAS:
      return { ...state, duvidas: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_PAUTA:
      return { ...state, loadingAgenciasPauta: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOAD_VOTOS_INCONSISTENTES:
      return { ...state, votosInconsistentes: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOADING_VOTOS_INCONSISTENTES:
      return { ...state, loadingVotosInconsistentes: action.payload };
    case ASSEMBLEIAS_ASSESSOR_ACTIONS_ALTERAR_STATUS_PAUTA:
      return {
        ...state,
        evento: {
          ...(state.evento || {}),
          // needLoadPautas: true,
        },
      };
    case ASSEMBLEIAS_ASSESSOR_UPDATE_QUORUM:
      return {
        ...state,
        evento: {
          ...state.evento,
          needLoadQuorum: false,
          existeQuorum: action.payload,
        },
      };
    case ASSEMBLEIAS_ASSESSOR_UPDATE_VOTATION:
      return {
        ...state,
        evento: {
          ...state.evento,
          needLoadQuorum: false,
          flagIniciarVotacaoDigital: action.payload,
        },
      };
    case ASSEMBLEIAS_ASSESSOR_LOADING_AGENCIAS_NUCLEOS_SEM_VOTO:
      return { ...state, loadingAgenciasNucleosSemVoto: action.payload };
    case ASSEMBLEIAS_ASSESSOR_LOADED_AGENCIAS_NUCLEOS_SEM_VOTO:
      return { ...state, agenciasNucleosSemVoto: action.payload };
    case ASSEMBLEIAS_ASSESSOR_EDITED:
      return {
        ...state,
        needLoadListaEvento: true,
        evento: { ...(state.evento || {}), needLoadAssembleia: true },
      };
    case AUTH_ACTIONS_LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
